import React from "react";
import Sidebar from "../../Sidebar";

export default function PatientModuleLayout({
    sidebarOpen,
    setSidebarOpen,
    sidebarOpenDesktop,
    currentScreen = "Pacientes",
    loading = false,
    header,
    children,
}) {
    return (
        <div className="min-h-screen bg-slate-100 dark:bg-slate-900">
            <Sidebar
                currentScreen={currentScreen}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                sidebarOpenDesktop={sidebarOpenDesktop}
            />

            {loading ? (
                <div className="flex min-h-screen items-center justify-center">
                    <div className="h-16 w-16 animate-spin rounded-full border-b-2 border-blue-900 dark:border-white" />
                </div>
            ) : (
                <div
                    className={`flex min-h-screen flex-1 flex-col transition-all ${
                        sidebarOpenDesktop ? "lg:pl-64" : ""
                    }`}
                >
                    {header}
                    <main className="flex-1 overflow-y-auto">{children}</main>
                </div>
            )}
        </div>
    );
}
